import React from 'react'
import './home.css'
import Navigation from '../../components/navigation'
import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'

export const ConfigureGooglePage = ({ isAllowed }) => {
  return (
    <>
      <Navigation isAllowed={isAllowed} theme={THEMES.dark} />

      <section className='header-to-dark darker padding140-150 box-shadow' style={{ minHeight: 'calc(100vh - 277px)' }}>
        <div className='container860 config-article'>
          <h1 style={{ marginBottom: 30 }}>Configure Google Workspace</h1>

          <p>
            Pen Protect sends phishing e-mails. Therefore, without proper configuration, some of these e-mails
            <strong> would not pass Google’s spam filter</strong>. This would be unfortunate because it would compromise
            your campaign statistics.
          </p>
          <p>
            The following guide explains how to avoid this phenomenon, and how to allow your campaigns to run smoothly.
          </p>
          <h2>1) Open Google Workspace admin</h2>
          <p>
            To allow Pen Protect to work, you will need to add the IP address we use to send our e-mails. Go to
            <a href='https://admin.google.com/ac/apps/gmail/spam?hl=en'>
              {' '}
              Gmail spam, phishing and malware settings
            </a>{' '}
            on your Google Workspace administration to add it.
          </p>
          <p>
            <a href='https://admin.google.com/ac/apps/gmail/spam?hl=en'>Open Google Workspace →</a>
          </p>
          <h2>2) Whitelist the IP address</h2>
          <p>
            The IP address we will use to send our emails is <strong>198.244.61.71</strong>. This IP address is
            <strong>dedicated to Pen Protect</strong> and won’t be used by any third parties.
          </p>
          <p>
            In the Email whitelist section, add the IP, and <strong>don’t forget to SAVE</strong>.
          </p>
          <img src='images/configure/google-config-1.png' alt='' />
          <h2>3) Configure the inbound gateway</h2>
          <p>You will find 2 sections below the Inbound gateway section. Go ahead and open it.</p>
          <img src='images/configure/google-config-2.png' alt='' />
          <p>
            First, start by enabling it by checking the first checkbox. Then, add the IP: <strong>198.244.61.71</strong>
            . You can check the Require TLS checkbox, and you NEED to check the Message is considered spam if… checkbox.
          </p>
          <p>
            In the Regexp field, enter anything, for example <strong>azertyuiopqsdfghjklm</strong>.
          </p>
          <p>Finally, check the Disable Gmail spam evaluation checkbox, and click the ADD SETTING button to save.</p>
          <p>
            You will have to <strong>save by clicking on the SAVE button</strong>.
          </p>
          <p>
            <strong>Careful</strong>: if you check by accident the Reject all mail not from gateway IPs, all inbound
            emails will be rejected.
          </p>
          <h2>4) Turn off the grey warning</h2>
          <p>
            It’s very likely that the following warning will be displayed by Gmail to your employees in your attacks:
          </p>
          <img src='images/configure/google-config-3.jpg' alt='' />
          <p>Fortunately, it’s very easy to get rid of those. We send all our emails from the domain names:</p>
          <ul>
            <li>auto-reply.link</li>
            <li>atlassian-no-reply.com</li>
            <li>auto-invoicing.com</li>
            <li>auto-response.com</li>
            <li>aws-cloud.co</li>
            <li>penprotect.ai</li>
            <li>norpl.co</li>
            <li>authlnk.com</li>
            <li>authlnk.net</li>
            <li>email-zendesk.com</li>
            <li>gitlab.email</li>
            <li>google-work.space</li>
            <li>google-workspace.com.pl</li>
            <li>microsoft-no-reply.com</li>
            <li>no-reply.com.pl</li>
            <li>office365noreply.com</li>
          </ul>
          <p>
            We will have to tell Google that any email from this domain name is legitimate. To do that, first you will
            have to create a new address list from the{' '}
            <a href='https://admin.google.com/ac/apps/gmail/manageaddresslist?addressListType=1'>
              Manage address lists settings
            </a>
            . Then click on <strong>Add address list</strong>. It will open the following window:
          </p>
          <img src='images/configure/google-config-4.png' alt='' />
          <p>
            Configure this window by adding the domain names. Then save everything, and close this settings page and
            reopen the{' '}
            <a href='https://admin.google.com/ac/apps/gmail/spam?hl=en'>Gmail spam, phishing and malware settings</a>{' '}
            page, we’re going to add this list we just created in both the <strong>Spam</strong> and{' '}
            <strong>Blocked senders</strong> sections.
          </p>
          <img src='images/configure/google-config-5.png' alt='' />
          <p>
            First, in the Spam section, click the <strong>Configure</strong> button, then a new window appears.
            Configure it the following way:
          </p>
          <img src='images/configure/google-config-6.png' alt='' />
          <p>
            And don’t forget to save. Then, in the Blocked senders section, click the <strong>Configure</strong> button
            and set it up this way:
          </p>
          <img src='images/configure/google-config-7.png' alt='' />
          <p>Then again don’t forget to save. And in a few minutes, the grey warning will have disappeared.</p>
          <h2>5) Try it out</h2>
          <p>
            Now that you have configured Google Workspace to receive Pen Protect emails,{' '}
            <strong>go back to the platform</strong> and test the configuration.
          </p>
          <p>
            <strong>Please note</strong>: the configuration may take a few minutes to propagate. If everything is well
            configured and you encounter a problem, wait 10 minutes and try again.
          </p>
          <h2>6) I still have the grey warning (optional)</h2>
          <p>
            If you still have the grey warning although you followed this guide step-by-step, that’s probably because
            you have the Enhanced pre-delivery message scanning feature activated. It’s activated by default{' '}
            <strong> if you’re not on the basic plan</strong>. Unfortunately, disabling it would reduce the protection
            of your workspace. What you can do though is temporarily deactivate it while you launch your phishing
            campaign, then reactivate it just right after.
          </p>
          <img src='images/configure/google-config-8.png' alt='' />
          <p>
            To do that, go to{' '}
            <a href='https://admin.google.com/ac/apps/gmail/spam?hl=en'>Gmail spam, phishing and malware settings</a> on
            your Google Workspace administration, and expand the 2nd section. Then, uncheck the checkbox and save. Now,
            launch your campaign. Wait a few minutes, then reactivate it.
          </p>
          <p>
            The emails are evaluated by Google only when they are received. That’s why we only need to disable this
            setting while we launch our campaign.
          </p>
          <h2>7) Turn off whitelist alerts (optional)</h2>
          <p>A new feature on Google Workspace will notify you if your whitelist settings are suspicious.</p>
          <p>
            Those emails tend to be annoying, but they are very easy to turn off. Open{' '}
            <a href='https://admin.google.com/ac/ax/details?alertType=10'>the security rule</a>, and click the Edit rule
            button.
          </p>
          <img src='images/configure/google-config-9.png' alt='' />
          <p>
            Then click Next again and again to the 3rd step Add actions, and uncheck Send email notifications there.
          </p>
          <p>
            Then save the edited rule and you should be good to go. You might receive additional email notifications
            because of Pen Protect, and you can repeat this operation for other rules{' '}
            <a href='https://admin.google.com/ac/ax?ruleTypeFilter=ALERT_CENTER'>in the Alert center</a> if you want.
          </p>
        </div>
      </section>
      <Footer isAllowed={isAllowed} theme={THEMES.dark} />
    </>
  )
}
